import WRAP from "WRAP-JS";
import {
  configHimawariDhFdCb,
  configHimawariDhFdCbDev,
  configHimawariDhFdIrht,
  configHimawariDhFdIrtp,
  configHimawariDhFdVis,
  configHimawariDhFdVws,
  configHimawariDhFdWv,
  configHimawariDhFdIrDiff,
  configHimawariDhJpIrht,
  configHimawariDhJpIrtp,
  configHimawariDhJpVis,
  configHimawariDhJpWv,
  configHimawariLayerCb,
  configHimawariLayerCbDev,
  configHimawariLayerIrht,
  configHimawariLayerIrtp,
  configHimawariLayerVis,
  configHimawariLayerVws,
  configHimawariLayerWv,
  configHimawariLayerIrDiff,
} from "./config/ConfigHimawari";
import { parseUTCDate } from "../../../utils/FPEUtils";
import LegendHimawari from "../legend/LegendHimawari";
import { WX_ID_HIMAWARI } from "../../../store/WeatherContentsState";
import TimeController from "../helper/TimeController";
import { nearValidTime } from "../helper/MapUtil";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";
import { TOOLTIP_GROUP_1 } from "../Map";

export const HIMAWARI_AREA_FD = 'FD';
export const HIMAWARI_AREA_JP = 'JP';

export const HIMAWARI_TYPE_IRHT = 'IRHT';
export const HIMAWARI_TYPE_IRHT_COLOR = 'IRHT_COLOR';
export const HIMAWARI_TYPE_IRTP = 'IRTP';
export const HIMAWARI_TYPE_IRTP_COLOR = 'IRTP_COLOR';
export const HIMAWARI_TYPE_WV = 'WV';
export const HIMAWARI_TYPE_VIS = 'VIS';
export const HIMAWARI_TYPE_VAA = 'VAA';
export const HIMAWARI_TYPE_CB = 'CB';
export const HIMAWARI_TYPE_IRDIFF = 'IRDIFF';

const styles = {
  [HIMAWARI_TYPE_IRHT_COLOR]: ['default'],
  [HIMAWARI_TYPE_IRHT]: ['monochrome'],
  [HIMAWARI_TYPE_IRTP_COLOR]: ['default'],
  [HIMAWARI_TYPE_IRTP]: ['monochrome'],
  [HIMAWARI_TYPE_WV]: ['default'],
  [HIMAWARI_TYPE_VIS]: ['default'],
  [HIMAWARI_TYPE_VAA]: ['default'],
  [HIMAWARI_TYPE_CB]: ['default', 'default', 'monochrome'],
  [HIMAWARI_TYPE_IRDIFF]: ['default'],
};

const MISSING_THRESHOLD = {
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRHT}`]: 1800,
  [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRHT}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRTP}`]: 1800,
  [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRTP}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_WV}`]: 1800,
  [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_WV}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VIS}`]: 1800,
  [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_VIS}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VAA}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_DEV`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_IRHT`]: 1800,
  [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRDIFF}`]: 1800,
};

class Himawari {
  static NAME = WX_ID_HIMAWARI;
  dataType;
  areaType;
  changeDataTypeFlg = false;

  // dhFd
  dhFdIrht;
  dhFdIrtp;
  dhFdWv;
  dhFdVis;
  dhFdVws;
  dhFdCb;
  dhFdCbDev;
  dhFdIrhtForCb;
  dhFdIrDiff;
  // dhJp
  dhJpIrht;
  dhJpIrtp;
  dhJpWv;
  dhJpVis;
  
  dhAutoUpdate = {
    [HIMAWARI_AREA_FD]: {
      [HIMAWARI_TYPE_IRHT]: true,
      [HIMAWARI_TYPE_IRTP]: true,
      [HIMAWARI_TYPE_WV]: true,
      [HIMAWARI_TYPE_VIS]: true,
      [HIMAWARI_TYPE_VAA]: true,
      [HIMAWARI_TYPE_CB]: true,
      [HIMAWARI_TYPE_IRDIFF]: true,
    },
    [HIMAWARI_AREA_JP]: {
      [HIMAWARI_TYPE_IRHT]: true,
      [HIMAWARI_TYPE_IRTP]: true,
      [HIMAWARI_TYPE_WV]: true,
      [HIMAWARI_TYPE_VIS]: true
    }
  };

  // layerFd
  layerFdIrht;
  layerFdIrtp;
  layerFdWv;
  layerFdVis;
  layerFdVws;
  layerFdCb;
  layerFdCbDev;
  layerFdIrhtForCb;
  layerFdIrDiff;
  // layerJp
  layerJpIrht;
  layerJpIrtp;
  layerJpWv;
  layerJpVis;
  
  etd;
  elapsed = 0;
  dispatcher;
  visible;

  typeInitialized = {
    [HIMAWARI_AREA_FD]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: false,
      [HIMAWARI_TYPE_IRHT]: false,
      [HIMAWARI_TYPE_IRTP_COLOR]: false,
      [HIMAWARI_TYPE_IRTP]: false,
      [HIMAWARI_TYPE_WV]: false,
      [HIMAWARI_TYPE_VIS]: false,
      [HIMAWARI_TYPE_VAA]: false,
      [HIMAWARI_TYPE_CB]: false,
      [HIMAWARI_TYPE_IRDIFF]: false,
    },
    [HIMAWARI_AREA_JP]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: false,
      [HIMAWARI_TYPE_IRHT]: false,
      [HIMAWARI_TYPE_IRTP_COLOR]: false,
      [HIMAWARI_TYPE_IRTP]: false,
      [HIMAWARI_TYPE_WV]: false,
      [HIMAWARI_TYPE_VIS]: false
    }
  };

  typeValidTimeInfo = {
    [HIMAWARI_AREA_FD]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: '---',
      [HIMAWARI_TYPE_IRHT]: '---',
      [HIMAWARI_TYPE_IRTP_COLOR]: '---',
      [HIMAWARI_TYPE_IRTP]: '---',
      [HIMAWARI_TYPE_WV]: '---',
      [HIMAWARI_TYPE_VIS]: '---',
      [HIMAWARI_TYPE_VAA]: '---',
      [HIMAWARI_TYPE_CB]: '---',
      [HIMAWARI_TYPE_IRDIFF]: '---',
    },
    [HIMAWARI_AREA_JP]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: '---',
      [HIMAWARI_TYPE_IRHT]: '---',
      [HIMAWARI_TYPE_IRTP_COLOR]: '---',
      [HIMAWARI_TYPE_IRTP]: '---',
      [HIMAWARI_TYPE_WV]: '---',
      [HIMAWARI_TYPE_VIS]: '---'
    }
  };

  // タイムコントローラー
  himawariTimeController;
  // タイムコントローラーのリスト
  timeList = {
    [HIMAWARI_AREA_FD]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: undefined,
      [HIMAWARI_TYPE_IRHT]: undefined,
      [HIMAWARI_TYPE_IRTP_COLOR]: undefined,
      [HIMAWARI_TYPE_IRTP]: undefined,
      [HIMAWARI_TYPE_WV]: undefined,
      [HIMAWARI_TYPE_VIS]: undefined,
      [HIMAWARI_TYPE_VAA]: undefined,
      [HIMAWARI_TYPE_CB]: undefined,
      [HIMAWARI_TYPE_IRDIFF]: undefined,
    },
    [HIMAWARI_AREA_JP]: {
      [HIMAWARI_TYPE_IRHT_COLOR]: undefined,
      [HIMAWARI_TYPE_IRHT]: undefined,
      [HIMAWARI_TYPE_IRTP_COLOR]: undefined,
      [HIMAWARI_TYPE_IRTP]: undefined,
      [HIMAWARI_TYPE_WV]: undefined,
      [HIMAWARI_TYPE_VIS]: undefined
    }
  }

  typeVisible = {
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRHT}`]: false,
    [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRHT}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRTP}`]: false,
    [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRTP}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_WV}`]: false,
    [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_WV}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VIS}`]: false,
    [`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_VIS}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VAA}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_DEV`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_IRHT`]: false,
    [`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRDIFF}`]: false,
  }
  // 自動更新フラグ
  autoRefresh = true;
  errorMessageInfo = {};
  
  constructor() {
    this.himawariTimeController = new TimeController(WX_ID_HIMAWARI, {
      label: 'Himawari',
      getTimeList: () => {
        const tList = this.timeList[this.areaType][this.dataType];
        if (tList) {
          return tList;
        }
        this._updateTimeList();
        return tList;
      },
      updated: () => {
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      },
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg);
      }
    });
    this.areaType = HIMAWARI_AREA_JP;

    // Fd layer
    this.layerFdIrht = new WRAP.Geo.Layer('HIMAWARI_FD_IRHT');
    this.layerFdIrtp = new WRAP.Geo.Layer('HIMAWARI_FD_IRTP');
    this.layerFdWv = new WRAP.Geo.Layer('HIMAWARI_FD_WV');
    this.layerFdVis = new WRAP.Geo.Layer('HIMAWARI_FD_VIS');
    this.layerFdVws = new WRAP.Geo.Layer('HIMAWARI_FD_VIS');
    this.layerFdCb = new WRAP.Geo.Layer('HIMAWARI_FD_CB');
    this.layerFdCbDev = new WRAP.Geo.Layer('HIMAWARI_FD_CB_DEV');
    this.layerFdIrhtForCb = new WRAP.Geo.Layer('HIMAWARI_FD_IRHT_FOR_CB');
    this.layerFdIrDiff = new WRAP.Geo.Layer('HIMAWARI_FD_IRDIFF');

    this.layerFdIrht.setVisible(false);
    this.layerFdIrtp.setVisible(false);
    this.layerFdWv.setVisible(false);
    this.layerFdVis.setVisible(false);
    this.layerFdVws.setVisible(false);
    this.layerFdCb.setVisible(false);
    this.layerFdCbDev.setVisible(false);
    this.layerFdIrhtForCb.setVisible(false);
    this.layerFdIrDiff.setVisible(false);

    this.layerFdIrtp.disableInteraction(true);
    this.layerFdWv.disableInteraction(true);
    this.layerFdVis.disableInteraction(true);
    this.layerFdVws.disableInteraction(true);
    this.layerFdCb.disableInteraction(true);
    this.layerFdCbDev.disableInteraction(true);
    this.layerFdIrDiff.disableInteraction(true);

    this.layerFdIrht.setTooltip(this._tooltipIrht);
    this.layerFdIrht.setRespondable(true);
    this.layerFdIrhtForCb.setTooltip(this._tooltipIrht);
    this.layerFdIrhtForCb.setRespondable(true);

    // Jp layer
    this.layerJpIrht = new WRAP.Geo.Layer('HIMAWARI_JP_IRHT');
    this.layerJpIrtp = new WRAP.Geo.Layer('HIMAWARI_JP_IRTP');
    this.layerJpWv = new WRAP.Geo.Layer('HIMAWARI_JP_WV');
    this.layerJpVis = new WRAP.Geo.Layer('HIMAWARI_JP_VIS');
    
    this.layerJpIrht.setVisible(false);
    this.layerJpIrtp.setVisible(false);
    this.layerJpWv.setVisible(false);
    this.layerJpVis.setVisible(false);

    this.layerJpIrtp.disableInteraction(true);
    this.layerJpWv.disableInteraction(true);
    this.layerJpVis.disableInteraction(true);

    this.layerJpIrht.setTooltip(this._tooltipIrht);
    this.layerJpIrht.setRespondable(true);

  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this.typeVisible);
  }

  setHimawariTypeInfoDispatcher(dispatcher) {
    this.himawariDispatcher = dispatcher;
  }

  async initialize(dataType, areaType=this.areaType) {
    await this.initData(dataType, areaType);
    this.initLayer(dataType, areaType);
    this.initTimeController(dataType, areaType);
  }

  initData(dataType, areaType) {
    return new Promise(resolveAll => {

      const isFd = areaType === HIMAWARI_AREA_FD;
      const dh = [];
      const types = [];

      switch (dataType) {
        case HIMAWARI_TYPE_IRHT_COLOR:
        case HIMAWARI_TYPE_IRHT:
          if (isFd) {
            dh.push(this.dhFdIrht = new WRAP.Data(configHimawariDhFdIrht));
            this.dhFdIrht.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRHT}`, this.dhFdIrht, this.layerFdIrht);
          } else {
            dh.push(this.dhJpIrht = new WRAP.Data(configHimawariDhJpIrht));
            this.dhJpIrht.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRHT}`, this.dhJpIrht, this.layerJpIrht);
          }
          types.push(HIMAWARI_TYPE_IRHT_COLOR);
          types.push(HIMAWARI_TYPE_IRHT);
          break;
        case HIMAWARI_TYPE_IRTP_COLOR:
        case HIMAWARI_TYPE_IRTP:
          if (isFd) {
            dh.push(this.dhFdIrtp = new WRAP.Data(configHimawariDhFdIrtp));
            this.dhFdIrtp.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRTP}`, this.dhFdIrtp, this.layerFdIrtp);
          } else {
            dh.push(this.dhJpIrtp = new WRAP.Data(configHimawariDhJpIrtp));
            this.dhJpIrtp.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_IRTP}`, this.dhJpIrtp, this.layerJpIrtp);
          }
          types.push(HIMAWARI_TYPE_IRTP_COLOR);
          types.push(HIMAWARI_TYPE_IRTP);
          break;
        case HIMAWARI_TYPE_WV:
          if (isFd) {
            dh.push(this.dhFdWv = new WRAP.Data(configHimawariDhFdWv));
            this.dhFdWv.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_WV}`, this.dhFdWv, this.layerFdWv);
          } else {
            dh.push(this.dhJpWv = new WRAP.Data(configHimawariDhJpWv));
            this.dhJpWv.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_WV}`, this.dhJpWv, this.layerJpWv);
          }
          types.push(HIMAWARI_TYPE_WV);
          break;
        case HIMAWARI_TYPE_VIS:
          if (isFd) {
            dh.push(this.dhFdVis = new WRAP.Data(configHimawariDhFdVis));
            this.dhFdVis.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VIS}`, this.dhFdVis, this.layerFdVis);
          } else {
            dh.push(this.dhJpVis = new WRAP.Data(configHimawariDhJpVis));
            this.dhJpVis.validate((displayTime, data, content) => {
              return this._validateTime(data, displayTime, content);
            });
            this.missingDataObserver.monitoring(`${HIMAWARI_AREA_JP}${HIMAWARI_TYPE_VIS}`, this.dhJpVis, this.layerJpVis);
          }
          types.push(HIMAWARI_TYPE_VIS);
          break;
        case HIMAWARI_TYPE_VAA:
          dh.push(this.dhFdVws = new WRAP.Data(configHimawariDhFdVws));
          this.dhFdVws.validate((displayTime, data, content) => {
            return this._validateTime(data, displayTime, content);
          });
          this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_VAA}`, this.dhFdVws, this.layerFdVws);
          types.push(HIMAWARI_TYPE_VAA);
          break;
        case HIMAWARI_TYPE_CB:
          dh.push(this.dhFdCb = new WRAP.Data(configHimawariDhFdCb));
          this.dhFdCb.validate((displayTime, data, content) => {
            return this._validateTime(data, displayTime, content);
          });
          this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}`, this.dhFdCb, this.layerFdCb);

          dh.push(this.dhFdCbDev = new WRAP.Data(configHimawariDhFdCbDev));
          this.dhFdCbDev.validate((displayTime, data, content) => {
            return this._validateTime(data, displayTime, content);
          });
          this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_DEV`, this.dhFdCbDev, this.layerFdCbDev);

          dh.push(this.dhFdIrhtForCb = new WRAP.Data(configHimawariDhFdIrht));
          this.dhFdIrhtForCb.validate((displayTime, data, content) => {
            return this._validateTime(data, displayTime, content);
          });
          this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_IRHT`, this.dhFdIrhtForCb, this.layerFdIrhtForCb);

          types.push(HIMAWARI_TYPE_CB);
          break;
        case HIMAWARI_TYPE_IRDIFF:
          dh.push(this.dhFdIrDiff = new WRAP.Data(configHimawariDhFdIrDiff));
          this.dhFdIrDiff.validate((displayTime, data, content) => {
            return this._validateTime(data, displayTime, content);
          });
          this.missingDataObserver.monitoring(`${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_IRDIFF}`, this.dhFdIrDiff, this.layerFdIrDiff);
          types.push(HIMAWARI_TYPE_IRDIFF);
          break;
        default:
      }

      const promises = [];
      dh.forEach(d => {
        promises.push(
          new Promise(resolve => {
            d.updated('validtime', (ref) => {
              this._selectValidTime(ref, dataType, areaType);
              resolve(ref);
            });
            d.updated('timelist', () => {
              if (this.errorMessageInfo[d.conf.data.Name]) {
                this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo[d.conf.data.Name]});
                this.errorMessageInfo[d.conf.data.Name] = null;
              }
            }, () => {
              this.errorMessageInfo[d.conf.data.Name] = this.dispatcher({type: 'SHOW_ERROR', payload: {
                message: `${d.conf.data.Name} timelist`,
                additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
              }});
            });
          })
        )
      });

      Promise.all(promises).then(refs => {
        types.forEach(dataType => {
          this.typeInitialized[areaType][dataType] = true;
        });
        resolveAll(refs);
      })
    });
  }

  initLayer(dataType, areaType) {
    const isFd = areaType === HIMAWARI_AREA_FD;
    switch (dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
      case HIMAWARI_TYPE_IRHT:
        if(isFd) {
          this.layerFdIrht.configure(this.dhFdIrht, configHimawariLayerIrht);
        } else {
          this.layerJpIrht.configure(this.dhJpIrht, configHimawariLayerIrht);
        }
        break;
      case HIMAWARI_TYPE_IRTP_COLOR:
      case HIMAWARI_TYPE_IRTP:
        if(isFd) {
          this.layerFdIrtp.configure(this.dhFdIrtp, configHimawariLayerIrtp);
        } else {
          this.layerJpIrtp.configure(this.dhJpIrtp, configHimawariLayerIrtp);
        }
        break;
      case HIMAWARI_TYPE_WV:
        if(isFd) {
          this.layerFdWv.configure(this.dhFdWv, configHimawariLayerWv);
        }else {
          this.layerJpWv.configure(this.dhJpWv, configHimawariLayerWv);
        }
        break;
      case HIMAWARI_TYPE_VIS:
        if(isFd) {
          this.layerFdVis.configure(this.dhFdVis, configHimawariLayerVis);
        } else {
          this.layerJpVis.configure(this.dhJpVis, configHimawariLayerVis);
        }
        break;
      case HIMAWARI_TYPE_VAA:
        this.layerFdVws.configure(this.dhFdVws, configHimawariLayerVws);
        break;
      case HIMAWARI_TYPE_CB:
        this.layerFdCb.configure(this.dhFdCb, configHimawariLayerCb);
        this.layerFdCbDev.configure(this.dhFdCbDev, configHimawariLayerCbDev);
        this.layerFdIrhtForCb.configure(this.dhFdIrhtForCb, configHimawariLayerIrht);
        break;
      case HIMAWARI_TYPE_IRDIFF:
        this.layerFdIrDiff.configure(this.dhFdIrDiff, configHimawariLayerIrDiff);
        break;
      default:
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.typeInitialized[this.areaType][this.dataType]) {
      await this.initialize(this.dataType);
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }

  getTooltipGroup() {
    return {
      id: TOOLTIP_GROUP_1,
      layers: [this.layerFdIrht, this.layerFdIrhtForCb, this.layerJpIrht]
    };
  }

  setVisible(visible, type=this.dataType, area=this.areaType) {
    if (!this.typeInitialized[area][type]) {
      return;
    }

    this._updateVisibleInfo(area, type, visible);

    const layers = this._getTargetLayer(type, area);

    const visibles = layers.map(layer => layer.visible());
    if(visibles.includes(visible)) return;

    if (visible) {
      layers.forEach((layer, index) => {
        layer.setStyle(styles[this.dataType][index]);
        layer.invalidate();
        layer.show()
      });
    } else {
      layers.forEach(layer => layer.hide());
    }

    const enabled = visible && this.autoRefresh;
    this.setAutoUpdate(enabled, type, area);
    this._updateTimeList();

    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  initTimeController(dataType, areaType) {
    const isFd = areaType === HIMAWARI_AREA_FD;
    switch(dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
      case HIMAWARI_TYPE_IRHT:
        isFd ? this.himawariTimeController.addLayer(this.layerFdIrht) : this.himawariTimeController.addLayer(this.layerJpIrht);
        break;
      case HIMAWARI_TYPE_IRTP_COLOR:
      case HIMAWARI_TYPE_IRTP:
        isFd ? this.himawariTimeController.addLayer(this.layerFdIrtp) : this.himawariTimeController.addLayer(this.layerJpIrtp);
        break;
      case HIMAWARI_TYPE_WV:
        isFd ? this.himawariTimeController.addLayer(this.layerFdWv) : this.himawariTimeController.addLayer(this.layerJpWv);
        break;
      case HIMAWARI_TYPE_VIS:
        isFd ? this.himawariTimeController.addLayer(this.layerFdVis) : this.himawariTimeController.addLayer(this.layerJpVis);
        break;
      case HIMAWARI_TYPE_VAA:
        this.himawariTimeController.addLayer(this.layerFdVws);
        break;
      case HIMAWARI_TYPE_CB:
        this.himawariTimeController.addLayer(this.layerFdCb);
        this.himawariTimeController.addLayer(this.layerFdCbDev);
        this.himawariTimeController.addLayer(this.layerFdIrhtForCb);
        break;
      case HIMAWARI_TYPE_IRDIFF:
        this.himawariTimeController.addLayer(this.layerFdIrDiff);
        break;
      default:
    }
    if (this.visible) {
      this.himawariTimeController.setDisplayTime(this.validTime);
    }
  }

  getTimeController() {
    return this.himawariTimeController;
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) return;
    this.autoRefresh = autoFlg;
    if (!this.typeInitialized[this.areaType][this.dataType]) return;
    this.setAutoUpdate(autoFlg, this.dataType, this.areaType);
  }

  setAutoUpdate(autoFlg, dataType, areaType) {
    const dhs = this._getTargetDh(dataType, areaType, true);
    dhs.forEach(data => {
      if (data.autoUpdate !== autoFlg) {
        const list = Array.isArray(data.dh) ? data.dh : [data.dh];
        list.forEach(dh => {
          dh.setAutoUpdate('validtime', autoFlg);
        });
        this.dhAutoUpdate[data.areaType][data.dataType] = autoFlg;
      }
    });
  }

  _updateTimeList() {
    if (!this.typeInitialized[this.areaType][this.dataType]) return;

    const dhs = this._getTargetDh();
    let validTimes;
    if (1 < dhs.length) {
      let tempTimeList = [];
      dhs.forEach(dh => {
        tempTimeList = tempTimeList.concat(dh.retained.validtime.validtime);
      });
      validTimes = tempTimeList.filter((value, index, self) => {
        return self.indexOf(value) === index && self.lastIndexOf(value) !== index;
      });
    } else {
      validTimes = dhs[0].retained.validtime.validtime;
    }
    this._filterTimeList(validTimes);

    if (this.autoRefresh) {
      this.himawariTimeController.setCurrentTime(this.validTime);
    }

    this.himawariTimeController.adjustCurrentTime();
    this.himawariTimeController.invalidate();
  }

  _validateTime(data, displayTime, content) {
    const vt = nearValidTime(data.retained.validtime.validtime, displayTime);
    if (vt) {
      this.validTime = content.validtime = vt;
      this._updateValidTimeInfo(this.dataType, vt, this.areaType);
      return true;
    }
    return false;
  }

  getTimeInformation(areaType=this.areaType) {
    let dataId;
    switch (this.dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
        dataId = `${areaType}${HIMAWARI_TYPE_IRHT}`;
        break;
      case HIMAWARI_TYPE_IRTP_COLOR:
        dataId = `${areaType}${HIMAWARI_TYPE_IRTP}`;
        break;
      case HIMAWARI_TYPE_CB:
        dataId = [
          `${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}`,
          `${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_DEV`,
          `${HIMAWARI_AREA_FD}${HIMAWARI_TYPE_CB}_IRHT`
        ];
        break;
      default:
        dataId = `${areaType}${this.dataType}`;
    }
    return {
      id: Himawari.NAME,
      label: 'Himawari',
      baseTime: {
        id: dataId,
        time:this.typeValidTimeInfo[areaType][this.dataType]
      }
    }
  }

  getLegend() {
    return {
      id: Himawari.NAME,
      label: 'Himawari',
      component: LegendHimawari,
      contents: this
    }
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.typeInitialized[this.areaType][this.dataType]) return;

    const dhs = this._getTargetDh();

    this._selectValidTime(dhs.map(dh => dh.retained.validtime));
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.typeInitialized[this.areaType][this.dataType]) return;

    const dhs = this._getTargetDh();

    this._selectValidTime(dhs.map(dh => dh.retained.validtime));
  }

  getAreaType() {
    return this.areaType;
  }

  async setAreaType(areaType, dataType) {
    await this.setDataType(dataType, areaType);
    this.areaType = areaType;
    this.himawariDispatcher({areaType: areaType, dataType: this.dataType});
  }

  getDataType() {
    return this.dataType;
  }

  async setDataType(dataType=this.dataType, areaType=this.areaType) {
    if (dataType === this.dataType && areaType === this.areaType) return;

    if (!this.visible) {
      this.dataType = dataType;
      this.himawariDispatcher({areaType: this.areaType, dataType: dataType});
      return;
    }

    this.changeDataTypeFlg = true;

    if (!this.typeInitialized[areaType][dataType]) {
      await this.initialize(dataType, areaType);
    }

    const currentLayers = this._getTargetLayer(this.dataType, this.areaType);
    const newLayers = this._getTargetLayer(dataType, areaType);

    if(areaType !== this.areaType) {
      newLayers.forEach((newLayer, index) => {
        newLayer.setStyle(styles[dataType][index]);
        newLayer.invalidate();
      });
      this.setVisible(false, this.dataType, this.areaType);
      this.dataType = dataType;
      this.areaType = areaType;
      this.setVisible(true, dataType, areaType);
    } else if (currentLayers.every(layer => newLayers.indexOf(layer) !== -1)) {
      //同じLayerの場合、カラー・モノクロのstyleの切り替え
      currentLayers.forEach((currentLayer, index) => {
        currentLayer.setStyle(styles[dataType][index]);
        currentLayer.invalidate();
      });
      this.dataType = dataType;
    } else {
      //現在のdataTypeを非表示
      this.setVisible(false);
      this.dataType = dataType;
      //切り替え後のdataTypeを表示
      this.setVisible(true);
      newLayers.forEach((newLayer, index) => {
        newLayer.setStyle(styles[dataType][index]);
        newLayer.invalidate();
      });
    }
    this.himawariDispatcher({areaType: this.areaType, dataType: dataType});
  }

  changeRoutePointEditing(routePointEditing) {
    this.layerFdIrht.disableInteraction(routePointEditing);
  }

  _selectValidTime(ref, dataType=this.dataType, areaType=this.areaType) {

    let timeList = ref;
    if (!timeList) return;

    if(dataType === HIMAWARI_TYPE_CB) {
      // CBは3つの元データに存在する時制のみに絞り込む
      const dhs = this._getTargetDh(dataType);
      let tempTimeList = [];
      let allUpdated = true;
      dhs.forEach(dh => {
        if(dh.retained.validtime) {
          tempTimeList = tempTimeList.concat(dh.retained.validtime.validtime);
        } else {
          allUpdated = false;
        }
      });
      if(!allUpdated) {
        return;
      }
      tempTimeList = tempTimeList.filter((value, index, self) => {
        return self.filter(s => s === value).length === 3;
      });
      timeList = Array.from(new Set(tempTimeList));
    } else {
      if(Array.isArray(timeList)) {
        timeList = timeList[0].validtime;
      } else {
        timeList = timeList.validtime;
      }
    }

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        targetTime = this.himawariTimeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const vt = nearValidTime(timeList, targetTime);
    const validTime = this.typeValidTimeInfo[areaType][dataType];

    if (vt && (validTime !== vt || this.changeDataTypeFlg)) {
      this.validTime = vt;
      this._updateValidTimeInfo(dataType, vt, areaType);
      this._updateDataset(dataType, areaType);
      this._updateTimeList();
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation(areaType)});
    }
  }

  _filterTimeList(timeList) {
    const maxValid = timeList.sort()[timeList.length - 1];
    const filterTime = parseUTCDate(maxValid).getTime() - (60 * 60 * 1000);

    this.timeList[this.areaType][this.dataType] = timeList.reduce((accumulator, validtime) => {
      const validSec = parseUTCDate(validtime).getTime();
      if (filterTime <= validSec) {
        accumulator.push(validtime);
      }
      return accumulator;
    }, []);
  }

  _updateValidTimeInfo(dataType, validTime, areaType) {
    switch (dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
      case HIMAWARI_TYPE_IRHT:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_IRHT_COLOR] = validTime;
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_IRHT] = validTime;
        break;
      case HIMAWARI_TYPE_IRTP_COLOR:
      case HIMAWARI_TYPE_IRTP:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_IRTP_COLOR] = validTime;
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_IRTP] = validTime;
        break;
      case HIMAWARI_TYPE_WV:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_WV] = validTime;
        break;
      case HIMAWARI_TYPE_VIS:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_VIS] = validTime;
        break;
      case HIMAWARI_TYPE_VAA:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_VAA] = validTime;
        break;
      case HIMAWARI_TYPE_CB:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_CB] = validTime;
        break;
      case HIMAWARI_TYPE_IRDIFF:
        this.typeValidTimeInfo[areaType][HIMAWARI_TYPE_IRDIFF] = validTime;
        break;
      default:
    }
  }

  _updateDataset(dataType, areaType) {
    const layers = this._getTargetLayer(dataType, areaType);
    if (this.typeValidTimeInfo[areaType][dataType] !== '---') {
      layers.forEach(layer => {
        layer.set({
          validtime: this.typeValidTimeInfo[areaType][dataType]
        });
      });
    }
  }

  _getTargetDh(dataType = this.dataType, areaType = this.areaType, withStatus = false) {
    const dhs = [];
    const isFd = areaType === HIMAWARI_AREA_FD;
    switch (dataType) {
      case HIMAWARI_TYPE_IRHT:
      case HIMAWARI_TYPE_IRHT_COLOR:
        dhs.push({
          dh: isFd ? this.dhFdIrht : this.dhJpIrht,
          autoUpdate: this.dhAutoUpdate[areaType][HIMAWARI_TYPE_IRHT],
          dataType: HIMAWARI_TYPE_IRHT,
          areaType
        });
        break;
      case HIMAWARI_TYPE_IRTP:
      case HIMAWARI_TYPE_IRTP_COLOR:
        dhs.push({
          dh: isFd ? this.dhFdIrtp : this.dhJpIrtp,
          autoUpdate: this.dhAutoUpdate[areaType][HIMAWARI_TYPE_IRTP],
          dataType: HIMAWARI_TYPE_IRTP,
          areaType
        });
        break;
      case HIMAWARI_TYPE_WV:
        dhs.push({
          dh: isFd ? this.dhFdWv : this.dhJpWv,
          autoUpdate: this.dhAutoUpdate[areaType][HIMAWARI_TYPE_WV],
          dataType: HIMAWARI_TYPE_WV,
          areaType
        });
        break;
      case HIMAWARI_TYPE_VIS:
        dhs.push({
          dh: isFd ? this.dhFdVis : this.dhJpVis,
          autoUpdate: this.dhAutoUpdate[areaType][HIMAWARI_TYPE_VIS],
          dataType: HIMAWARI_TYPE_VIS,
          areaType
        });
        break;
      case HIMAWARI_TYPE_VAA:
        dhs.push({
          dh: this.dhFdVws,
          autoUpdate: this.dhAutoUpdate[HIMAWARI_AREA_FD][HIMAWARI_TYPE_VAA],
          dataType: HIMAWARI_TYPE_VAA,
          areaType: HIMAWARI_AREA_FD
        });
        break;
      case HIMAWARI_TYPE_CB:
        dhs.push({
          dh: [this.dhFdCb, this.dhFdCbDev, this.dhFdIrhtForCb],
          autoUpdate: this.dhAutoUpdate[HIMAWARI_AREA_FD][HIMAWARI_TYPE_CB],
          dataType: HIMAWARI_TYPE_CB,
          areaType: HIMAWARI_AREA_FD
        });
        break;
      case HIMAWARI_TYPE_IRDIFF:
        dhs.push({
          dh: this.dhFdIrDiff,
          autoUpdate: this.dhAutoUpdate[HIMAWARI_AREA_FD][HIMAWARI_TYPE_IRDIFF],
          dataType: HIMAWARI_TYPE_IRDIFF,
          areaType: HIMAWARI_AREA_FD
        });
        break;
      default:
    }
    return withStatus ? dhs : dhs.flatMap(d=>d.dh);
  }

  _getTargetLayer(dataType = this.dataType, areaType = this.areaType) {
    const layers = [];
    const isFd = areaType === HIMAWARI_AREA_FD;
    switch (dataType) {
      case HIMAWARI_TYPE_IRHT:
      case HIMAWARI_TYPE_IRHT_COLOR:
        layers.push(isFd ? this.layerFdIrht : this.layerJpIrht);
        break;
      case HIMAWARI_TYPE_IRTP:
      case HIMAWARI_TYPE_IRTP_COLOR:
        layers.push(isFd ? this.layerFdIrtp : this.layerJpIrtp);
        break;
      case HIMAWARI_TYPE_WV:
        layers.push(isFd ? this.layerFdWv : this.layerJpWv);
        break;
      case HIMAWARI_TYPE_VIS:
        layers.push(isFd ? this.layerFdVis : this.layerJpVis);
        break;
      case HIMAWARI_TYPE_VAA:
        layers.push(this.layerFdVws);
        break;
      case HIMAWARI_TYPE_CB:
        layers.push(this.layerFdCb);
        layers.push(this.layerFdCbDev);
        layers.push(this.layerFdIrhtForCb);
        break;
      case HIMAWARI_TYPE_IRDIFF:
        layers.push(this.layerFdIrDiff);
        break;
      default:
    }
    return layers;
  }

  _tooltipIrht(geo) {
    const prop = geo && geo.properties;
    if (prop) {
      const val = prop.data[0];
      if (val > 1) {
        let ft = 58.82352941 * val;
        ft *= 3.281;
        return `<ul><li>CLD: ${Math.round(ft)}ft</li></ul>`;
      }
    }
    return null
  }

  _allLayers() {
    return [
      this.layerFdIrht,
      this.layerFdIrtp,
      this.layerFdWv,
      this.layerFdVis,
      this.layerFdVws,
      this.layerFdIrhtForCb,
      this.layerFdCb,
      this.layerFdCbDev,
      this.layerFdIrDiff,
      this.layerJpIrht,
      this.layerJpIrtp,
      this.layerJpWv,
      this.layerJpVis,
    ];
  }

  _updateVisibleInfo(area, dataType, visible) {
    let type;
    switch (dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
        type = [HIMAWARI_TYPE_IRHT]
        break;
      case HIMAWARI_TYPE_IRTP_COLOR:
        type = [HIMAWARI_TYPE_IRTP];
        break;
      case HIMAWARI_TYPE_CB:
        type = [HIMAWARI_TYPE_CB, `${HIMAWARI_TYPE_CB}_DEV`, `${HIMAWARI_TYPE_CB}_IRHT`];
        break;
      default:
        type = [dataType];
    }
    type.forEach(t => {
      const key = `${area}${t}`;
      Object.keys(this.typeVisible).forEach(visibleKey => {
        if (key === visibleKey) {
          if (this.typeVisible[visibleKey] !== visible) {
            this.typeVisible[visibleKey] = visible;
          }
        }
      });
    });
  }

  isDrawCoastLineOverContents(dataType = this.dataType) {
    let drawCoastLine = false;
    if(dataType === HIMAWARI_TYPE_VAA) {
      drawCoastLine = true;
    }
    return drawCoastLine;
  }
}

export default Himawari;